module.exports = __webpack_public_path__ + "media/images/icons/twotone/code-dee9efdafe9e43522b845e55320943ac.svg";